import React, { useState, useEffect } from "react";
import { Tabela } from "shared/components/table/Tabela";
import { TableColumn } from "../../../types/table/TableColumn";
import { Col, Container, Fade, Form, Row } from "react-bootstrap";
import { Select, MenuItem, SelectChangeEvent } from "@mui/material";
import { TipoStatusAtivacao } from "types/dto/groupsign/TipoStatusAtivacao";
import { RenderRowsConfiguracaoCondominio } from "./RenderRowsConfiguracaoCondominio";
import { useGetConfigAssDigitalCondominioPaginadas } from "hooks/groupsign/useGetConfigAssDigitalCondominioPaginadas";
import InputSearch from "shared/components/input/InputSearch";

const INITIAL_PARAMS = {
  size: 10,
  page: 0,
  sort: "",
  tipoStatusAtivacao: "AMBOS",
  nomeCondominio: "",
};

const TAB_COLUMNS: TableColumn[] = [
  { id: "nomeCondominio", label: "Condomínio", isOrdenavel: true, width: "30%" },
  { id: "cnpj", label: "CNPJ", isOrdenavel: false, width: "30%" },
  { id: "isAtivo", label: "Status da Assinatura", isOrdenavel: false, width: "20%" },
];

export const TabConfiguracaoCondominio: React.FC = () => {
  const [searchCondominio, setSearchCondominio] = useState<string>("");
  const [statusAtivacao, setStatusAtivacao] = useState<TipoStatusAtivacao>("AMBOS");
  const [ordenarPorColuna, setOrdenarPorColuna] = useState<string>("nome");
  const [ordenacaoAscOuDesc, setOrdenacaoAscOuDesc] = useState<"ASC" | "DESC">("ASC");
  const [sortString, setSortString] = useState<string>("condominio.pessoaJuridica.nomeFantasia,ASC");
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [mostrarConteudo, setMostrarConteudo] = useState<boolean>(false);
  const [configuracoesPaginadas, setConfiguracoesPaginadas] = useState<any>(null);

  const params = {
    ...INITIAL_PARAMS,
    page: paginaAtual - 1,
    sort: sortString,
    tipoStatusAtivacao: statusAtivacao,
    nomeCondominio: searchCondominio,
  };

  const {
    data: configuracoesPaginadasResponse,
    isFetching,
    refetch,
  } = useGetConfigAssDigitalCondominioPaginadas(params);

  useEffect(() => {
    if (configuracoesPaginadasResponse) {
      setConfiguracoesPaginadas(configuracoesPaginadasResponse.content);
    }
  }, [configuracoesPaginadasResponse]);

  useEffect(() => {
    setPaginaAtual(1);
    refetch();
  }, [statusAtivacao, searchCondominio, refetch]);

  useEffect(() => {
    setMostrarConteudo(true);
  }, []);

  const handleSearchChange = (value: string) => setSearchCondominio(value);

  const handleStatusChange = (event: SelectChangeEvent<string>) => {
    setStatusAtivacao(event.target.value as TipoStatusAtivacao);
  };

  const handleSortChange = (idColuna: string) => {
    const novaOrdenacao = ordenarPorColuna === idColuna && ordenacaoAscOuDesc === "ASC" ? "DESC" : "ASC";
    setOrdenacaoAscOuDesc(novaOrdenacao);
    setOrdenarPorColuna(idColuna);
    setSortString(`condominio.pessoaJuridica.nomeFantasia,${novaOrdenacao}`);
    setPaginaAtual(1);
  };

  const renderCampoBusca = () => (
    <>
      <Col xs={5} className="me-4">
        <InputSearch
          id="buscar-config-ass-digital-condominio"
          key="buscar-config-ass-digital-condominio"
          label="Buscar:"
          placeholder="Buscar condomínio"
          onSearchChange={handleSearchChange}
        />
      </Col>
      <Col xs={6} className="me-4">
        <span className="label-input"> Status </span>
        <Form.Group style={{ width: "100%" }}>
          <Select
            labelId="status-ativacao-label"
            value={statusAtivacao}
            onChange={handleStatusChange}
            sx={{ width: "35%", height: "38px", fontSize: "0.875rem" }}
          >
            <MenuItem value="AMBOS">Ambos</MenuItem>
            <MenuItem value="ATIVO">Ativada</MenuItem>
            <MenuItem value="INATIVO">Desativada</MenuItem>
          </Select>
        </Form.Group>
      </Col>
    </>
  );

  const renderTabelaConfiguracao = () => (
    <Col xs={12}>
      <Tabela
        id="tabela-configuracao-assinatura"
        colunas={TAB_COLUMNS}
        ordernarPorColuna={ordenarPorColuna}
        ordenacaoAscOuDesc={ordenacaoAscOuDesc}
        ordenarRegistrosFunction={handleSortChange}
        onChangePageFunction={setPaginaAtual}
        paginaAtual={paginaAtual}
        quantidadeDePaginas={configuracoesPaginadasResponse?.totalPages ?? 0}
        renderCheckBox={false}
        isLoading={isFetching}
        quantidadeDeRegistros={configuracoesPaginadasResponse?.totalElements ?? 0}
      >
        <RenderRowsConfiguracaoCondominio configsAssDigital={configuracoesPaginadas ?? []} refetch={refetch} />
      </Tabela>
    </Col>
  );

  return (
    <Container>
      <Fade in={mostrarConteudo} timeout={700}>
        <div>
          <Row>{renderCampoBusca()}</Row>
          <Row>{renderTabelaConfiguracao()}</Row>
        </div>
      </Fade>
    </Container>
  );
};
